export const $nav = (targets, method = 'push') => {
  targets = Array.isArray(targets) ? targets : [targets]
  const urlParams = new URLSearchParams(window.location.search)
  for (const target of targets) {
    urlParams.set(`__${target.name}`, target.href)
  }
  const newUrl = new URL(window.location.href)
  newUrl.search = urlParams.toString()

  if (method === 'replace') {
    window.history.replaceState({}, '', newUrl.toString())
  } else {
    window.history.pushState({}, '', newUrl.toString())
  }
}
